import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// Resets scroll to the top on every client-side route change so navigating from
// the bottom of one page doesn't land you at the bottom of the next. The site sets
// `html { scroll-behavior: smooth }` globally, so we temporarily override it to a
// jump for route changes (and restore it after, keeping in-page anchor links smooth).
// If the URL has a #hash, it scrolls to that element instead. SSG-safe (client-only).
export default function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    const html = document.documentElement
    const previous = html.style.scrollBehavior
    html.style.scrollBehavior = 'auto'

    const target = hash ? document.getElementById(hash.slice(1)) : null
    if (target) {
      target.scrollIntoView()
    } else {
      window.scrollTo(0, 0)
    }

    html.style.scrollBehavior = previous
  }, [pathname, hash])

  return null
}
